import { useEffect } from "react";
import { api, type WgOverview } from "../api";

/**
 * Den Konzentrator live mitlesen, solange die Seite offen ist.
 *
 * Der Server schickt nur bei echten Änderungen (core/views_wg.py) — kein
 * Intervall im Browser, kein F5. Bewusst nur die Konzentrator-Hälfte: die
 * Uplink-Zeilen der Router frisch zu holen hieße, fünfzig Router zu wecken,
 * und dafür ist der Stream nicht da (docs/conventions.md, Priorität 2).
 */
export function useWgStream(onData: (overview: WgOverview) => void): void {
  useEffect(() => {
    // Absichtlich ohne `onData` in den Abhängigkeiten: der Aufrufer gibt in der
    // Regel eine frisch erzeugte Funktion herein, und die würde den Stream bei
    // jedem Rendern neu aufbauen — also je Zuschauer eine neue Verbindung pro
    // Zustandsänderung.
    return api.streamWireguard(onData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
